import React, { useEffect, useState } from 'react';
import { useAuthorizedUser } from '@vtblife/block-kit-utils';
import { quizService } from '../../utils/quiz.service';
import { QuizContent } from '../quiz-content/quiz-content';
import { QuizModalLayout } from './components/quiz-modal-layout/quiz-modal-layout';
import { sendQuizAnalytics } from '../../utils/quiz-analytics';
import { getLastSavedStepIndex } from './get-last-saved-step-index';
export const QuizModal = (props) => {
    const user = useAuthorizedUser();
    const { onNextStep: _onNextStep, settings } = props;
    const { id } = settings;
    useEffect(() => {
        if (props.isOpen && id && (user === null || user === void 0 ? void 0 : user.userId) !== undefined) {
            const touchQuiz = async () => {
                try {
                    quizService.touchQuiz({
                        id,
                        userId: user === null || user === void 0 ? void 0 : user.userId,
                    });
                }
                catch (error) {
                    console.error('Ошибка сохранения факта просмотра квиза', error);
                }
            };
            touchQuiz();
        }
    }, [props.isOpen, id, user === null || user === void 0 ? void 0 : user.userId]);
    const onNextStep = async (data) => {
        if (id) {
            const { lastStep, step, stepIndex, fields } = data;
            await quizService.createOrUpdateQuizStep({
                id,
                fields,
                ended: lastStep,
                step: stepIndex,
                stepName: step.description || 'empty',
                userId: user === null || user === void 0 ? void 0 : user.userId,
            });
            await (_onNextStep === null || _onNextStep === void 0 ? void 0 : _onNextStep(data));
        }
    };
    return React.createElement(QuizModalInner, { ...props, user: user, onNextStep: onNextStep });
};
export const QuizModalInner = ({ isOpen, onClose, settings, onLastStepSubmit, onNextStep, user }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const { id } = settings;
    const handleClose = ({ quizStep, quizAction = 'close', quizChoice, isResultStep, }) => {
        if (typeof quizStep !== 'undefined') {
            sendQuizAnalytics({ quizName: settings.name, quizId: id, quizStep, quizAction, quizChoice });
        }
        if (id) {
            const lastSavedStepIndex = getLastSavedStepIndex({ isResultStep, quizStep, settings });
            quizService
                .closeQuizStep({
                id,
                userId: user === null || user === void 0 ? void 0 : user.userId,
                step: lastSavedStepIndex,
            })
                .catch((error) => console.error('Ошибка сохранения факта закрытия квиза', error));
        }
        onClose();
    };
    const onComplete = async ({ quizStep, quizAction, quizChoice, }) => {
        handleClose({ quizStep, quizAction, quizChoice, isResultStep: true });
    };
    const { background, layout, disableClosing } = settings;
    return (React.createElement(QuizModalLayout, { background: background, layout: layout, onClose: handleClose, open: isOpen, currentStep: currentStep, disableClosing: disableClosing },
        React.createElement(QuizContent, { onLastStepSubmit: onLastStepSubmit, onComplete: onComplete, onNextStep: onNextStep, setCurrentStep: setCurrentStep, ...settings })));
};
//# sourceMappingURL=quiz-modal.js.map